function commonExtendsHOC(WrappedComponent){
    return WrappedComponent
    // return class extendsHOC extends WrappedComponent {
    //     render(){
    //         //使用super调用传入组件的render方法
    //         return super.render();
    //     }
    // }
}
export default commonExtendsHOC;